import { Box, LinearProgress, Typography } from '@mui/material'

interface IProps {
	progress: number
	label?: string
	error?: boolean
	warning?: boolean
}
const ProgressBar = (props: IProps) => {
	const { progress, label, error, warning } = props
	return (
		<Box sx={{ width: '100%' }}>
			{label && (
				<Typography variant="subtitle2" gutterBottom component="div">
					{label}
				</Typography>
			)}
			<LinearProgress
				color={error ? 'error' : warning ? 'warning' : 'primary'}
				variant="determinate"
				value={progress}
			/>
		</Box>
	)
}

export { ProgressBar }
